import React, { FC, useState } from 'react'
import styles from 'styles/components/list.module.scss'
import { Accordion, AccordionItem } from 'components/Accordion'
import { useToggleBoolean } from 'hooks/form'
import format from 'date-fns/format'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { ShopStripePayout } from 'types/graphql'

type Props = {
  payouts: ShopStripePayout[]
  year: number
}

const DepositHistoryListItem: FC<Props> = React.memo((props) => {
  const { payouts, year } = props
  const dispatch = useDispatch()
  const [isExpanded, setExpanded] = useState<boolean>(false)
  const toggleExpanded = useToggleBoolean(setExpanded)
  const handleConfirmDetail = (payoutId: string) => dispatch(push(`/account/revenue/deposit_history/${payoutId}`))
  return (
    <Accordion handleExpand={toggleExpanded} isExpand={isExpanded} label={`${year}年`}>
      <AccordionItem>
        <ul className={styles.monthlyReport__list}>
          {payouts.map((payout) => (
            <li key={payout.createdDate} className={styles.monthlyReport__list__item}>
              <span>{format(new Date(payout.createdDate), 'MM月dd日 HH:mm 申請')}</span>
              <a
                className={styles.monthlyReport__link}
                onClick={() => handleConfirmDetail(payout.payoutId)}
                role={'button'}
              >
                確認する
              </a>
            </li>
          ))}
        </ul>
      </AccordionItem>
    </Accordion>
  )
})

export default DepositHistoryListItem
